import { Nullable } from '../../types/common'
import BaseComponent from '../base-component/base-component'
import Cart from './cart'

class CartOrderNotesBlock extends BaseComponent {
  cart: Nullable<Cart>

  constructor() {
    super()

    this.cart = this.closest('cart-page')
  }

  connectedCallback(): void {
    if (this.cart) {
      this.cart.subscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  disconnectedCallback(): void {
    if (this.cart) {
      this.cart.unsubscribe('update-nodes', this.handleFinishCartUpdate)
    }
  }

  handleFinishCartUpdate = ({ node }): void => {
    this.updateByNode(node)
  }

  updateByNode(node: HTMLElement): void {
    const blockId = this.getAttribute('block-id')
    const newOrderNotesBlock = node.querySelector(
      `cart-order-notes-block[block-id="${blockId}"]`,
    )

    if (!newOrderNotesBlock) {
      return
    }

    const clonedNewOrderNotesBlock = newOrderNotesBlock.cloneNode(true)

    this.replaceChildren(...clonedNewOrderNotesBlock.childNodes)
  }
}

export default CartOrderNotesBlock
